import React, { useEffect } from "react";

import Popup from "./Popup";

import axiosInstance from "../apis/gvmdesk";
import useAxiosFunction from "../hooks/useAxiosFunction";
import LoadingCenter from "./LoadingCenter";

const PopupLiberate = props => {
  const { admin } = props;
  const [response, setResponse, loading, error, axiosFetch] = useAxiosFunction();

  useEffect(() => {
    if (admin) {
      axiosFetch({
        axiosInstance,
        method: "GET",
        url: "/users/admin/all/by/" + admin.id,
        redirect_to: ""
      });
    }
  }, [props.trigger === true]);


  const onSubmit = (event) => {
    event.preventDefault();

    console.log("The form is submitted!");
  }

  return (
    <Popup title={`Liberar clientes de ${admin && admin.name}`} trigger={props.trigger} setTrigger={props.setTrigger} >
      <form onSubmit={onSubmit}>
        <div>
          <ul className="contact__list">
            {loading && <LoadingCenter />}

            {!loading && response?.contacts?.length > 0
              && <div className="x-p-20 y-p-10 text-color">O(a) vendedor(a) {admin.name} possui {response?.contacts?.length} clientes.</div>}
          </ul>
        </div>

        <div className="popup-footer x-p-20 y-p-20">
          <button className="btn btn-primary" type="submit">Confirmar liberação</button>
          <button className="btn btn-light mr-20" type="button" onClick={() => props.setTrigger(false)}>Cancelar</button>
        </div>
      </form>
    </Popup >
  );
}

export default PopupLiberate;